// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { SYSTEM } from '../internal/environment';
import customCssProps from '../internal/generated/custom-css-properties';
export function getRootStyles(style) {
    var _a, _b, _c, _d, _e, _f;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        background: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.background,
        borderColor: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderColor,
        // Set as a custom property, not inline `border-radius`, so stacked containers can still
        // flatten their adjacent corners in CSS.
        ...(((_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.borderRadius) && { [customCssProps.containerStyleBorderRadius]: style.root.borderRadius }),
        borderWidth: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.borderWidth,
        boxShadow: (_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.boxShadow,
        color: (_f = style === null || style === void 0 ? void 0 : style.root) === null || _f === void 0 ? void 0 : _f.color,
    };
}
export function getContentStyles(style) {
    var _a, _b;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        paddingBlock: (_a = style === null || style === void 0 ? void 0 : style.content) === null || _a === void 0 ? void 0 : _a.paddingBlock,
        paddingInline: (_b = style === null || style === void 0 ? void 0 : style.content) === null || _b === void 0 ? void 0 : _b.paddingInline,
    };
}
export function getHeaderStyles(style) {
    var _a, _b, _c, _d;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        ...(((_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.background) && { background: 'transparent' }), // Fix for AWSUI-61442
        // Same as the root: use a custom property so stacked headers can still flatten corners in CSS.
        ...(((_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderRadius) && { [customCssProps.containerStyleBorderRadius]: style.root.borderRadius }),
        paddingBlock: (_c = style === null || style === void 0 ? void 0 : style.header) === null || _c === void 0 ? void 0 : _c.paddingBlock,
        paddingInline: (_d = style === null || style === void 0 ? void 0 : style.header) === null || _d === void 0 ? void 0 : _d.paddingInline,
    };
}
export function getFooterStyles(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        borderColor: (_b = (_a = style === null || style === void 0 ? void 0 : style.footer) === null || _a === void 0 ? void 0 : _a.divider) === null || _b === void 0 ? void 0 : _b.borderColor,
        borderWidth: (_d = (_c = style === null || style === void 0 ? void 0 : style.footer) === null || _c === void 0 ? void 0 : _c.divider) === null || _d === void 0 ? void 0 : _d.borderWidth,
        paddingBlock: (_f = (_e = style === null || style === void 0 ? void 0 : style.footer) === null || _e === void 0 ? void 0 : _e.root) === null || _f === void 0 ? void 0 : _f.paddingBlock,
        paddingInline: (_h = (_g = style === null || style === void 0 ? void 0 : style.footer) === null || _g === void 0 ? void 0 : _g.root) === null || _h === void 0 ? void 0 : _h.paddingInline,
    };
}
export function getMediaStyles(mediaPosition, style) {
    var _a;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        borderRadius: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.borderRadius,
        ...(mediaPosition === 'top' && { borderEndStartRadius: '0px', borderEndEndRadius: '0px' }),
        ...(mediaPosition === 'side' && { borderStartEndRadius: '0px', borderEndEndRadius: '0px' }),
    };
}
//# sourceMappingURL=style.js.map